import {
  LOAD_PROVINCE_SUCCESS,
  SELECT_PROVINCE,
  RESET_PROVINCE,
} from './types'

export const loadProvinceJson = () => ({
  type: LOAD_PROVINCE_SUCCESS,
})

export const handleSelectProvince = amphures => ({
  type: SELECT_PROVINCE,
  data: amphures,
})

export const handleResetProvince = () => ({
  type: RESET_PROVINCE,
})




// WEBPACK FOOTER //
// ./src/actions/province.js